import * as React from "react";
import {
  ImageField,
  Create,
  TextInput,
  ImageInput,
  BooleanInput,
  NumberInput,
} from "react-admin";
import { SimpleForm } from "../common/SimpleForm";
import { IMAGE_MAX_SIZE } from "../constants/FileConstants";
import { validateOrder, validateRequired } from "../utils/Validations";

const CategoryCreate = () => (
  <Create title="Crear Categoría" mutationMode="pessimistic">
    <SimpleForm>
      <TextInput source="name" label="Nombre" validate={validateRequired} />
      <ImageInput
        source="image"
        label="Imagen"
        accept={{
          "image/*": [],
        }}
        validate={validateRequired}
        maxSize={IMAGE_MAX_SIZE}
      >
        <ImageField source="src" title="Imagen" />
      </ImageInput>
      <NumberInput
        source="order"
        label="Orden"
        min={1}
        validate={validateOrder}
        onWheel={(e) => e.target.blur()}
      />
      <BooleanInput source="visible" label="Visible" defaultValue={true} />
      <BooleanInput source="active" label="Activo" defaultValue={true} />
    </SimpleForm>
  </Create>
);

export default CategoryCreate;
